import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@rogers/cdk/tile';
import { TileComponent } from '@rogers/cdk/tile';
import * as i1$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
const _c0 = [[["", "header", ""]], [["", "body", ""]]];
const _c1 = ["[header]", "[body]"];
let TileWithHeaderComponent = /*#__PURE__*/(() => {
  class TileWithHeaderComponent {
    constructor() {
      this.headerClass = 'px-32 py-24';
    }
    /** @nocollapse */
    static {
      this.ɵfac = function TileWithHeaderComponent_Factory(t) {
        return new (t || TileWithHeaderComponent)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TileWithHeaderComponent,
        selectors: [["ss-tile-with-header"]],
        inputs: {
          headerClass: "headerClass",
          bodyClass: "bodyClass"
        },
        ngContentSelectors: _c1,
        decls: 5,
        vars: 3,
        consts: [[1, "ds-bgcolor-misty", 3, "ngClass"]],
        template: function TileWithHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "ds-tile")(1, "div", 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div");
            i0.ɵɵprojection(4, 1);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.headerClass);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMap(ctx.bodyClass);
          }
        },
        dependencies: [i1.NgClass, i2.TileComponent],
        encapsulation: 2
      });
    }
  }
  return TileWithHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TileWithHeaderModule = /*#__PURE__*/(() => {
  class TileWithHeaderModule {
    /** @nocollapse */static {
      this.ɵfac = function TileWithHeaderModule_Factory(t) {
        return new (t || TileWithHeaderModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TileWithHeaderModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule.forChild(), TileComponent]
      });
    }
  }
  return TileWithHeaderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TileWithHeaderComponent, TileWithHeaderModule };
